import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import TertiaryTopRoundButton from "../../../components/_utils/CommonButtons/TertiaryTopRoundButton/TertiaryTopRoundButton";
import TopBarButtons from "../../../components/_utils/CommonButtons/TopBarButton";
import CommonCardDashboard from "../../../components/_utils/CommonCardDashboard";
import SourceDestinationAccountDetailVariant from "../../../components/_utils/TransactionCommonComponents/SourceDestinationAccountDetailVariant";
import WeeklySchedulesCard from "../../../components/_utils/WeeklySchedulesCard";
import QuickActionCard from "../../../components/QuickActionCard/QuickActionCard";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { getAllfieldForceTxn } from "../../../redux/features/fieldForceTransaction";
import {
  approveFieldForceRequest,
  getAllFieldForceRequest,
} from "../../../redux/features/fieldForceRequest";

import {
  GlobalConfiguration,
  PaginationConfiguration,
  TimelineConfiguration,
} from "../../../utils/configurationProvider";
import TEXT from "../../../utils/globalText";
import formatTotalBalance from "../../../utils/formatTotalBalance";
import accountNameStandardised from "../../../utils/accountNamestandardised";
import { toast } from "react-toastify";
import { toast_position } from "../../../redux/features/Settings/Authorization";

const FieldForceTxnDashboard = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [currentSlide, setCurrentSlide] = useState(0);
  const [txnCountLoading, setTxnCountLoading] = useState(true);

  const [txnPayLoad, setTxnPayLoad] = useState();
  const [openOwner, setOpenOwner] = useState(false);
  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const {
    allFieldForceRequestTransactionsData,
    allFieldForceRequestTransactionsLoading,
  } = useSelector((state) => state.fieldForceRequest);

  const { fieldForceRequestApprovalData } = useSelector(
    (state) => state.fieldForceRequest,
  );

  const pendingRequestCount =
    fieldForceRequestApprovalData?.total_count ||
    GlobalConfiguration?.lengthCheckZero;

  const {
    fieldForceTxnViewAllLoading,
    summary: txnSummary,
    totalCount: txnTotalCount,
  } = useSelector((state) => state.fieldForceTransaction);

  const requireApprovalTxnCount =
    txnSummary?.actionable_transaction_count ||
    GlobalConfiguration?.lengthCheckZero;

  const pendingTxnCount =
    txnSummary?.pending_transaction_count ||
    GlobalConfiguration?.lengthCheckZero;

  const approvedTxnCount =
    txnSummary?.approved_transaction_count ||
    GlobalConfiguration?.lengthCheckZero;

  const isViewAllDisabled =
    fieldForceTxnViewAllLoading ||
    txnCountLoading ||
    txnTotalCount === GlobalConfiguration?.lengthCheckZero;

  const onMount = () => {
    (async () => {
      await Promise.allSettled([
        dispatch(
          getAllfieldForceTxn({
            page_no: 1,
            page_size: PaginationConfiguration.paginationSmall,
          }),
        ),
        dispatch(
          getAllFieldForceRequest({
            page_no: 1,
            page_item_count: PaginationConfiguration.paginationSmall,
          }),
        ),
      ]);
      setTxnCountLoading(false);
    })();
  };

  useEffect(() => {
    dispatch(enableSwitcher());

    (async () => {
      await onMount();
    })();

    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    onMount();
  }, [markerData]);

  const handleDatacardClick = (approvalStatus, distributionStatus) => {
    const routeMap = {
      approved:
        "/field_force_transaction_dashboard/field_force_transaction_view_all",
      pending:
        "/field_force_transaction_dashboard/field_force_transaction_view_all",
      require:
        "/field_force_transaction_dashboard/field_force_transaction_single_approval",
    };

    navigate(routeMap[approvalStatus], {
      state: {
        approvalStatus,
      },
    });
  };

  const formatPendingCount = (count, services, serviceName) => {
    const hasService = (services || []).includes(serviceName);

    if (!hasService) {
      return "N/A";
    }

    if (!count || count === GlobalConfiguration?.lengthCheckZero) {
      return "00";
    }

    const digitCount = count.toString().length;

    if (digitCount <= GlobalConfiguration?.categoryminLength) {
      return count
        .toLocaleString("en-IN")
        .padStart(TimelineConfiguration?.barWidthMedium, "0");
    }

    const maxForDigits =
      Math.pow(
        GlobalConfiguration?.panLength,
        digitCount - GlobalConfiguration?.lengthCheckOne,
      ) - GlobalConfiguration?.lengthCheckOne;

    return `${maxForDigits.toLocaleString("en-IN")}+`;
  };

  const slides = Array.from({ length: 0 }, (_, i) => `Slide ${i + 1}`);

  const nextSlide = () => {
    if (currentSlide < slides.length - GlobalConfiguration?.lengthCheckOne) {
      setCurrentSlide(currentSlide + GlobalConfiguration?.lengthCheckOne);
    }
  };

  const prevSlide = () => {
    if (currentSlide > GlobalConfiguration?.lengthCheckZero) {
      setCurrentSlide(currentSlide - GlobalConfiguration?.lengthCheckOne);
    }
  };

  const CREATE_REQUEST_SERVICES = ["CFieldForceTxn", "AFieldForceRequest"];

  const handleCreateRequest = () => {
    const userServices = services || [];

    const hasAnyService = CREATE_REQUEST_SERVICES.some((s) =>
      userServices.includes(s),
    );

    if (hasAnyService) {
      navigate("/field_force_transaction_dashboard/create_field_force_request");
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: CREATE_REQUEST_SERVICES },
      });
    }
  };

  const handleViewRequest = () => {
    if ((services || []).includes("VFieldForceTxn")) {
      navigate(
        "/field_force_transaction_dashboard/field_force_request_view_all",
      );
    } else {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "VFieldForceTxn" },
      });
    }
  };

  useEffect(() => {
    dispatch(
      approveFieldForceRequest({
        entityId: markerData?.entity_id,
      }),
    );
  }, [markerData]);

  const requests = allFieldForceRequestTransactionsData?.requests || [];

  const safeServices = Array.isArray(services) ? services : [];

  const hasTxnApprovalService = services?.includes("AFieldForceTxn");

  const approvalService = "AFieldForceRequest";
  const hasApprovalRequestService = safeServices.includes(approvalService);
  const hasPendingRequests =
    pendingRequestCount > GlobalConfiguration?.lengthCheckZero;

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };

  const handleRequestNavigation = () => {
    if (!hasApprovalRequestService) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: approvalService },
      });
      return;
    }
    if (!hasPendingRequests) {
      return;
    }

    navigate(
      "/field_force_transaction_dashboard/field_force_request_single_approval",
    );
  };

  return (
    <div
      style={{ height: "var(--full-height)" }}
      className={` internalDashboardView bg-primary-bg w-width-full px-padding-md overflow-y-auto Qlg:px-padding-base pb-padding-md
  Qsmd:pb-padding-base
  Qlg:pb-padding-md`}
    >
      <div className="h-navbar-height Qsmd:h-navbar-breadcrumb-height"></div>
      <div className="pb-padding-lg Qsmd:pb-padding-base">
        <div className="flex flex-col mt-margin-md Qlg:mx-auto pb-padding-lg Qsmd:pb-padding-base max-w-tab-width-normal w-width-full Qlg:flex-row  Qlg:mb-margin-base Qlg:relative">
          <div className="Qlg:w-dashboard-left-card-width flex flex-col">
            <div className="w-width-full p-padding-sm fixed top-top-base left-left-base right-right-base bg-text-primary flex items-center z-z-index-tooltip Qlg:hidden rounded-bl-border-radius-sm rounded-br-border-radius-sm">
              <div className="flex flex-row items-center">
                <img
                  src={ICONS.FIELD_FORCE_TRANSACTION_BLUE_CIRCLE}
                  alt="Xpentra Logo"
                  className="h-icon-lg w-icon-lg mr-margin-sm"
                />
                <div className="flex flex-col">
                  <div className="flex items-center">
                    <p className="text-primary-bg font-semibold text-font-md">
                      Field force
                    </p>
                  </div>
                  <p className="text-primary-bg text-font-xs">Transactions</p>
                </div>
              </div>
            </div>
            <div className="mt-margin-button-l Qsmd:mt-margin-base">
              <TopBarButtons
                services={services}
                items={[
                  {
                    imgColor: "var(--text-primary)",
                    icon: ICONS?.ADD_BUTTON,
                    label: <>Create field force transaction</>,
                    requiredservice: ["CFieldForceTxn"],
                    onClick: () =>
                      navigate(
                        "/field_force_transaction_dashboard/create_field_force_transaction",
                      ),
                  },
                ]}
              />
            </div>

            <div className="w-width-full bg-primary-card Qlg:mt-margin-md md:mt-margin-md sm:mt-margin-md mt-margin-md rounded-border-radius-md relative overflow-hidden">
              <h2 className="bg-primary-card flex items-center justify-between pl-padding-md text-text-primary transition-all duration-animation-medium">
                <div className="flex items-center text-sm font-semibold tracking-letter-space">
                  <img
                    src={ICONS?.APPROVAL_STATUS}
                    alt="transaction header"
                    className="w-icon-sm mr-margin-sm"
                  />
                  Approval statuses
                </div>
                <div className="flex">
                  <div className="border-dividing"></div>
                  <TertiaryTopRoundButton
                    btnText={TEXT?.VIEW_ALL}
                    icon={ICONS?.ARROW_RIGHT_WHITE}
                    imgColor="var(--text-primary)"
                    btnType="button"
                    hoverOption="white"
                    handleFunction={async () => {
                      const hasVFieldForceTxn =
                        Array.isArray(services) &&
                        services.includes("VFieldForceTxn");

                      if (hasVFieldForceTxn) {
                        if (isViewAllDisabled) return;
                        navigate(
                          "/field_force_transaction_dashboard/field_force_transaction_view_all",
                        );
                      } else {
                        navigate("/feature_not_assigned", {
                          state: { unavailableService: "VFieldForceTxn" },
                        });
                      }
                    }}
                    isDisabled={isViewAllDisabled}
                    // isDisabled={
                    //   !(
                    //     Array.isArray(services) &&
                    //     services.includes("VReimbursementTxn")
                    //   ) || fieldForceTxnViewAllLoading
                    // }
                    enabledTextColor={"var(--text-primary)"}
                    disabledTextColor={"var(--text-secondary)"}
                    enabledBgColor={"var(--primary-card)"}
                  />
                </div>
              </h2>

              <div className="flex flex-col Qmd:flex-row gap-gap-base p-padding-base bg-primary-nav">
                <CommonCardDashboard
                  label={TEXT?.REQUIRE_APPROVAL}
                  count={requireApprovalTxnCount ?? "00"}
                  color="var(--pending)"
                  loader={txnCountLoading || fieldForceTxnViewAllLoading}
                  onClick={() => {
                    // navigate(
                    //   "/field_force_transaction_dashboard/field_force_transaction_single_approval",
                    // );
                    toast.info("Feature coming soon !", toast_position);
                  }}
                  onServiceUnavailable={() =>
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "FieldForceTxn" },
                    })
                  }
                />

                <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base" />
                <CommonCardDashboard
                  label={TEXT?.PENDING_TRANSACTIONS}
                  count={
                    services?.includes("VFieldForceTxn")
                      ? (pendingTxnCount ?? "00")
                      : "N/A"
                  }
                  color="var(--pending)"
                  loader={txnCountLoading || fieldForceTxnViewAllLoading}
                  onClick={() => {
                    if (pendingTxnCount !== "00") {
                      handleDatacardClick("pending", "");
                    }
                  }}
                  onServiceUnavailable={() =>
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VFieldForceTxn" },
                    })
                  }
                />

                <div className="border-border border-primary-bg Qsmd:my-margin-md my-margin-base" />

                <CommonCardDashboard
                  label={TEXT?.APPROVED_TRANSACTIONS}
                  count={approvedTxnCount ?? "00"}
                  color="var(--awaiting)"
                  loader={txnCountLoading || fieldForceTxnViewAllLoading}
                  onClick={() => handleDatacardClick("approved", "")}
                  onServiceUnavailable={() =>
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "VFieldForceTxn" },
                    })
                  }
                  isDisabled={
                    approvedTxnCount === GlobalConfiguration?.lengthCheckZero ||
                    txnTotalCount === GlobalConfiguration?.lengthCheckZero
                  }
                />
              </div>
            </div>

            <div className="w-width-full mt-margin-md bg-primary-card rounded-t-border-radius-md rounded-b-border-radius-md">
              <h2 className="bg-primary-card flex items-center justify-between px-padding-md py-padding-sm text-sm font-semibold text-text-secondary transition-all duration-animation-medium rounded-t-border-radius-md">
                <span className="flex items-center text-sm font-semibold tracking-letter-space">
                  <img
                    src={ICONS?.STATISTICS}
                    alt="Statistics Header"
                    className="h-icon-sm mr-margin-sm"
                  />
                  Transactions count
                </span>
                {slides.length > GlobalConfiguration?.lengthCheckZero && (
                  <div className="flex items-center">
                    <div
                      onClick={prevSlide}
                      className={`cursor-pointer w-icon-sm h-icon-sm flex items-center justify-center mr-margin-sm ${
                        currentSlide === GlobalConfiguration?.lengthCheckZero
                          ? "opacity-light-opacity cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        pointerEvents:
                          currentSlide === GlobalConfiguration?.lengthCheckZero
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img
                        src={ICONS?.ARROW_LEFT_WHITE}
                        alt="Previous"
                        className="w-width-full h-height-full"
                      />
                    </div>
                    <div
                      onClick={nextSlide}
                      className={`cursor-pointer w-icon-sm h-icon-sm flex items-center justify-center ${
                        currentSlide ===
                        slides.length - GlobalConfiguration?.lengthCheckOne
                          ? "opacity-light-opacity cursor-not-allowed"
                          : ""
                      }`}
                      style={{
                        pointerEvents:
                          currentSlide ===
                          slides.length - GlobalConfiguration?.lengthCheckOne
                            ? "none"
                            : "auto",
                      }}
                    >
                      <img
                        src={ICONS?.ARROW_RIGHT_WHITE}
                        alt="Next"
                        className="w-width-full h-height-full"
                      />
                    </div>
                  </div>
                )}
              </h2>

              <div className="relative w-width-full Qlg:py-padding-md overflow-hidden contents Qlg:block">
                {slides.length > GlobalConfiguration?.lengthCheckZero ? (
                  <div
                    className="flex transition-transform duration-animation-medium ease-in-out"
                    style={{
                      transform: `translateX(-${currentSlide * TimelineConfiguration?.timeDuration}%)`,
                    }}
                  >
                    {slides.map((slide, index) => (
                      <div
                        key={index}
                        className="w-width-full flex-shrink-0 flex items-center justify-center"
                      >
                        {slide}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center Qlg:justify-start h-height-full text-center p-padding-md">
                    <div className="flex flex-col justify-center items-center w-width-full">
                      <img
                        src={ICONS?.NO_STATISTICS}
                        alt="No Slides"
                        className="mb-margin-md"
                      />
                      <p className="text-font-xs text-text-primary">
                        No statistics available due to the absence of data.{" "}
                        <br /> Once data is present, statistics will appear.
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="flex flex-col Qlg:gap-gap-md Qlg:w-dashboard-right-card-width mt-margin-md Qlg:mt-margin-base Qlg:absolute Qlg:h-full Qlg:right-right-base">
            <div>
              <WeeklySchedulesCard
                header={{
                  title: "Field force requests",
                  icon: ICONS.CALENDER,
                }}
                approval={{
                  service: "AFieldForceRequest",
                  count: pendingRequestCount,
                  label: "Require approval",
                  // onClick: handleRequestNavigation,
                  onClick: () => {
                    navigate(
                      "/field_force_transaction_dashboard/field_force_request_single_approval",
                    );
                    // toast.info("Feature coming soon !", toast_position);
                  },
                }}
                list={{
                  loading: allFieldForceRequestTransactionsLoading,
                  emptyText: "There are no more requests.",
                  data: requests,
                  getTitle: (row) =>
                    accountNameStandardised(row?.field_force_account_name) ||
                    "-",
                  getDate: (row) =>
                    `INR ${formatTotalBalance(Number(row?.amount) || GlobalConfiguration?.lengthCheckZero).amount}`,
                  titleLabel: "Account name",
                  dateLabel: "Amount",
                  labelColor: "var(--settled)",
                }}
                services={services}
                formatPendingCount={formatPendingCount}
                onFeatureNotAssigned={(missingServices) =>
                  navigate("/feature_not_assigned", {
                    state: { unavailableService: missingServices },
                  })
                }
                actions={[
                  {
                    label: "Create request",
                    isDisabled: true,
                    service: ["CFieldForceTxn"],
                    onClick: handleCreateRequest,
                    enabledBgColor: "var(--primary-nav-act)",
                    enabledTextColor: "var(--text-primary)",
                    outLineColor: "",
                    hoverOption: "white",
                    fullWidthRequired: true,
                  },
                  {
                    label: "View requests",
                    onClick: handleViewRequest,
                    service: ["VFieldForceTxn"],
                    isDisabled: true,
                    enabledBgColor: "var(--primary-nav-act)",
                    enabledTextColor: "var(--text-primary)",
                    outLineColor: "",
                    hoverOption: "white",
                    fullWidthRequired: true,
                  },
                ]}
              />
            </div>
            <div className="w-width-full Qlg:mt-margin-base mt-margin-md Qlg:max-w-[var(--create-box-width)]">
              <SourceDestinationAccountDetailVariant
                isDisabled={!services?.includes("VAccount")}
                type="source"
                modalOpen={openOwner}
                setModalOpen={setOpenOwner}
                txnPayLoad={txnPayLoad}
                setTxnPayLoad={setTxnPayLoad}
                handleOnAccountSelection={handleOwnerSelection}
              />
            </div>
            <div className="w-full Qlg:mt-margin-base mt-margin-base pb-padding-md">
              <QuickActionCard
                title="More actions"
                labels={["MIS report"]}
                labelDisabled={true}
                onClick={(label) => {
                  // if (label === "MIS report") {
                  //   const dashboardBasePath =
                  //     location.pathname.includes(
                  //       "reimbursement_transaction_dashboard",
                  //     ) && "/reimbursement_transaction_dashboard";
                  //   if ((services || []).includes("SMisUser")) {
                  //     navigate(`${dashboardBasePath}/generate_mis_report`);
                  //   } else {
                  //     navigate("/feature_not_assigned", {
                  //       state: { unavailableService: "SMisUser" },
                  //     });
                  //   }
                  // }
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FieldForceTxnDashboard;
